/* AnalogSetup — interacciones propias (galería, cantidad y barra de compra) */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Galería */
  function initGallery(root) {
    var stage = root.querySelector('[data-al-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-al-thumb]'));
    if (!stage || thumbs.length === 0) return;

    var slides = Array.prototype.slice.call(stage.querySelectorAll('img'));

    function show(index) {
      slides.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (btn, i) {
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        show(i);
      });
      btn.addEventListener('mouseenter', function () {
        show(i);
      });
    });

    show(0);
  }

  /* -------------------------------------------------------------- Cantidad */
  function initQuantity(root) {
    var input = root.querySelector('[data-al-qty-input]');
    if (!input) return;

    root.querySelectorAll('[data-al-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-al-qty') === 'plus' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId) return Promise.resolve();

    var errorEl = document.querySelector('[data-al-upsell-error]');
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.setAttribute('aria-busy', 'true');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'No se ha podido añadir');
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return response;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'analog-add',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.open === 'function') {
          cart.open(btn || cart);
        }

        return response;
      })
      .catch(function (error) {
        var el = document.querySelector('[data-al-upsell-error]');
        if (el) {
          el.textContent = error.message;
          el.hidden = false;
        }
        throw error;
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  /* ------------------------------------------------------------ Barra fija */
  function initStickyBar() {
    var bar = document.querySelector('[data-al-stickybar]');
    if (!bar) return;

    var anchorId = bar.getAttribute('data-al-anchor');
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    var footer = document.querySelector('.footer');

    var cta = bar.querySelector('[data-al-cta]');

    function setMode(count) {
      if (!cta) return;
      var hasItems = count > 0;
      cta.dataset.mode = hasItems ? 'cart' : 'buy';
      cta.textContent = hasItems
        ? cta.dataset.labelCart || 'Ver carrito'
        : cta.dataset.labelBuy || 'Comprar';
    }

    if (cta && !cta.dataset.alBound) {
      cta.dataset.alBound = 'true';

      cta.addEventListener('click', function (event) {
        if (cta.dataset.mode === 'cart') {
          event.preventDefault();
          event.stopPropagation();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(cta);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }
      });

      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          setMode(cart.item_count);
        })
        .catch(function () {});

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          var count = event && event.cartData ? event.cartData.item_count : null;
          setMode(typeof count === 'number' ? count : 1);
        });
      }
    }

    function update() {
      var pastAnchor = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', pastAnchor && !atFooter);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    update();
  }

  /* --------------------------------------------------- Scroll suave a compra */
  function initAnchors() {
    document.querySelectorAll('[data-al-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        var target = document.getElementById(el.getAttribute('data-al-scroll-to'));
        if (!target) return;
        event.preventDefault();
        // En móvil, ir directo a nombre + precio + botón (la galería ya se ha visto en el scroll).
        var focus = target.querySelector('[data-al-scroll-focus]');
        if (focus && window.matchMedia('(max-width: 749px)').matches) {
          window.scrollTo({ top: focus.getBoundingClientRect().top + window.pageYOffset - 16, behavior: 'smooth' });
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ------------------------------------------ Añadir al carrito (hero, CTA, upsell) */
  function initAddToCart() {
    if (document.body.dataset.alAddBound) return;
    document.body.dataset.alAddBound = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-al-add-to-cart], [data-al-upsell-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      if (btn.hasAttribute('data-al-cta') && btn.dataset.mode === 'cart') return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      event.preventDefault();
      addToCart(variantId, btn);
    });
  }

  /* ------------------------------------------- Avisos de pedidos (solo reales) */
  function initToasts() {
    var root = document.querySelector('[data-al-toasts]');
    if (!root || root.dataset.alBound) return;
    var items = [];
    var jsonEl = document.getElementById('al-toast-messages');
    try {
      if (jsonEl) {
        items = JSON.parse(jsonEl.textContent || '[]');
      } else {
        var parsed = JSON.parse(root.getAttribute('data-messages') || '[]');
        items = typeof parsed === 'string' ? parsed.split(/\n/) : parsed;
      }
    } catch (err) {
      items = [];
    }
    items = items
      .map(function (line) {
        return String(line).replace(/<br\s*\/?>/gi, '').trim();
      })
      .filter(Boolean);
    if (!items.length) return;
    root.dataset.alBound = 'true';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var i = 0;
    function show() {
      var msg = items[i % items.length];
      i += 1;
      root.textContent = msg;
      root.hidden = false;
      window.setTimeout(function () {
        root.hidden = true;
      }, 5200);
    }

    window.setTimeout(show, 9000);
    window.setInterval(show, 26000);
  }

  /* ------------------------------------------------ Carrito de la barra superior */
  function initTopbarCart() {
    if (document.body.dataset.alTopbarBound) return;
    document.body.dataset.alTopbarBound = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-al-open-cart]');
      if (!btn) return;

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(btn);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    });

    // El contador vive fuera del carrito lateral, así que Dawn no lo repinta.
    function refreshCount(count) {
      document.querySelectorAll('[data-al-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(cartUrl + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshCount(cart.item_count);
          })
          .catch(function () {});
      });
    }
  }

  /* ---------------------------------------------------------------------------
     Promesa de envío con la hora de corte real (hora de Madrid, lunes a viernes).
     «Pídelo antes de las 16:00 y sale hoy», cuenta atrás en las últimas 3 h,
     fecha de entrega = salida + días laborables de tránsito. Sin festivos.
     --------------------------------------------------------------------------- */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function madridNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Madrid',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var v = {};
      parts.forEach(function (p) {
        v[p.type] = parseInt(p.value, 10);
      });
      // Fecha «de calendario» de Madrid (sin zona) para contar días laborables.
      return { date: new Date(v.year, v.month - 1, v.day), minutes: (v.hour % 24) * 60 + v.minute };
    } catch (err) {
      return null;
    }
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n -= 1;
    }
    return d;
  }

  function shipPlan(cutoffHour, transit) {
    var now = madridNow();
    if (!now) return null;
    var dow = now.date.getDay();
    var weekday = dow >= 1 && dow <= 5;
    var left = cutoffHour * 60 - now.minutes;
    var ship;
    var when;
    if (weekday && left > 0) {
      ship = now.date;
      when = 'today';
    } else {
      ship = addBusinessDays(now.date, 1);
      var diff = Math.round((ship - now.date) / 86400000);
      when = diff === 1 ? 'tomorrow' : 'later';
    }
    return { when: when, left: left, ship: ship, arrive: addBusinessDays(ship, transit) };
  }

  function hhmm(h) {
    return (h < 10 ? '0' : '') + h + ':00';
  }

  function etaShipText(plan, cutoffHour) {
    if (plan.when === 'today') {
      if (plan.left <= 180) {
        var h = Math.floor(plan.left / 60);
        var m = plan.left % 60;
        return 'Pídelo en <strong>' + (h ? h + ' h ' : '') + m + ' min</strong> y sale hoy';
      }
      return 'Pídelo antes de las <strong>' + hhmm(cutoffHour) + '</strong> y sale hoy';
    }
    if (plan.when === 'tomorrow') return 'Pídelo ahora y <strong>sale mañana</strong>';
    return 'Pídelo ahora y <strong>sale el ' + DIAS[plan.ship.getDay()] + '</strong>';
  }

  function initShipEta() {
    var full = document.querySelectorAll('[data-al-eta]');
    var short = document.querySelectorAll('[data-al-eta-short]');
    if (!full.length && !short.length) return;

    function paint() {
      full.forEach(function (el) {
        var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 16;
        var transit = parseInt(el.getAttribute('data-transit'), 10) || 2;
        var plan = shipPlan(cutoff, transit);
        if (!plan) return;
        el.querySelector('[data-al-eta-ship]').innerHTML = etaShipText(plan, cutoff);
        el.querySelector('[data-al-eta-arrive]').textContent =
          'Te llega el ' + DIAS[plan.arrive.getDay()] + ' ' + plan.arrive.getDate() + ' de ' + MESES[plan.arrive.getMonth()];
        el.hidden = false;
      });
      short.forEach(function (el) {
        var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 16;
        var plan = shipPlan(cutoff, 2);
        if (!plan) return;
        el.textContent = plan.when === 'today' ? 'sale hoy' : plan.when === 'tomorrow' ? 'sale mañana' : 'sale el ' + DIAS[plan.ship.getDay()];
        el.hidden = false;
      });
    }

    paint();
    if (!initShipEta.timer) initShipEta.timer = window.setInterval(paint, 30000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-al-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-al-buy]').forEach(initQuantity);
    initShipEta();
    initStickyBar();
    initAnchors();
    initAddToCart();
    initToasts();
    initTopbarCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Re-inicializar al editar secciones en el editor de temas
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
